<template>
  <!-- Solo muestra el check si está aprobado y verificado -->
  <v-tooltip bottom v-if="isVerified && isApproved">
    <template v-slot:activator="{ on, attrs }">
      <v-icon 
        small 
        :color="iconColor" 
        class="verification-badge"
        v-bind="attrs"
        v-on="on"
        :style="{ fontSize: iconSize }"
      >
        mdi-check-circle
      </v-icon>
    </template>
    <span>Usuario Verificado</span>
  </v-tooltip>
</template>

<script>
import axios from "axios";

export default {
  name: 'VerificationBadge',
  props: {
    color: {
      type: String,
      default: 'success' // Color por defecto: verde
    },
    size: {
      type: String,
      default: 'small' // Tamaño por defecto
    }
  },
  data() {
    return {
      isVerified: false,
      isApproved: false,
      loading: false
    };
  },
  computed: {
    iconColor() {
      // Si el color es un nombre de color de Vuetify (success, primary, etc.)
      // o un color hexadecimal (#FF0000, etc.)
      return this.color;
    },
    iconSize() {
      // Mapear tamaños a valores de fuente
      const sizes = {
        'small': '16px',
        'medium': '20px',
        'large': '24px',
        'x-large': '28px'
      };
      return sizes[this.size] || '16px';
    }
  },
  mounted() {
    this.checkVerificationStatus();
  },
  methods: {
    async checkVerificationStatus() {
      try {
        this.loading = true;
        const response = await axios.get('/verification/status');
        const { verified, approved } = response.data;
        
        this.isVerified = verified;
        this.isApproved = approved;
        
      } catch (error) {
        console.error('Error checking verification status:', error);
        this.isVerified = false;
        this.isApproved = false;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.verification-badge {
  margin-left: 4px;
  vertical-align: middle;
}
</style>